import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: "Variety of Cars",
        content: "Choose from a wide range of vehicles to suit every journey, from compact city cars to spacious SUVs.",
        paragraphs: [
            "We offer an extensive selection of vehicles to match any travel need, whether you're heading out on a family vacation, a business trip, or a weekend getaway.",
            "Our fleet includes compact cars for city driving, mid-size sedans for comfort, SUVs for space and versatility, and even premium models for a touch of luxury."
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            "Diverse fleet with multiple vehicle categories",
            "Options for economy, comfort, and luxury",
            "Manual and automatic transmission choices",
            "Vehicles suitable for individuals, families, or groups",
            "Regularly updated fleet with new models"
        ],
        process: [
            "Explore our diverse car collection online",
            "Use filters to find a car that fits your needs",
            "Check availability and specifications",
            "Select your preferred vehicle",
            "Confirm your reservation in minutes"
        ],
        faqs: [
            {
                id: 1,
                heading: "What types of cars do you offer?",
                content: "We offer everything from compact cars and sedans to SUVs, vans, and luxury vehicles. There's something for every occasion and budget."
            },
            {
                id: 2,
                heading: "Can I choose a specific car model?",
                content: "While we guarantee the car category, specific models are subject to availability. We do our best to honor preferences."
            },
            {
                id: 3,
                heading: "Do you have cars with automatic transmission?",
                content: "Yes, both manual and automatic transmission options are available across various car types."
            },
            {
                id: 4,
                heading: "Is there a limit on how many passengers a car can carry?",
                content: "Each vehicle has a maximum passenger capacity listed. We offer options ranging from 2-seaters to 7+ seaters."
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: "Best Price Guarantee",
        content: "We offer the most competitive prices in the market. Enjoy great value without compromising on quality.",
        paragraphs: [
            "At our rental service, we are committed to providing the best possible rates for our vehicles without sacrificing quality.",
            "Our Best Price Guarantee ensures that you get top-notch service and reliable cars at prices that fit your budget. If you find a lower rate elsewhere, we’ll match it!"
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            "Competitive pricing on all vehicles",
            "No hidden fees or surprise charges",
            "Price match guarantee for similar offers",
            "Transparent billing and breakdown",
            "Seasonal discounts and promotions"
        ],
        process: [
            "Browse available cars and choose your preferred model",
            "Compare prices easily on our platform",
            "Book confidently knowing you're getting the best deal",
            "Provide proof if you find a lower rate — we’ll match it",
            "Enjoy your rental with peace of mind"
        ],
        faqs: [
            {
                id: 1,
                heading: "How does the Best Price Guarantee work?",
                content: "If you find a lower price for the same car and rental terms from another provider, we’ll match it or refund the difference."
            },
            {
                id: 2,
                heading: "Are there any conditions for price matching?",
                content: "Yes, the lower price must be for the same car model, rental period, and location. Promotional or third-party rates may not be eligible."
            },
            {
                id: 3,
                heading: "Do I need to provide proof of the lower price?",
                content: "Yes, a screenshot or official quote showing the lower price and rental details will be required for verification."
            },
            {
                id: 4,
                heading: "When will the refund or match be applied?",
                content: "Once verified, the price match will be applied before your payment is finalized, or we’ll refund the difference within 3-5 business days."
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: "Available 24 x 7",
        content: "Our car rental service is available 24/7 to meet your travel needs anytime, anywhere.",
        paragraphs: [
            "We understand that travel plans can change at any moment. That’s why our services are available around the clock to provide flexibility and peace of mind.",
            "Whether it's an early morning airport drop or a late-night emergency trip, our fleet and support team are ready to assist you 24 hours a day, 7 days a week."
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            "24/7 car rental availability",
            "Round-the-clock customer support",
            "Flexible pickup and drop-off times",
            "Real-time online booking system",
            "Emergency rental assistance anytime"
        ],
        process: [
            "Visit our website or app at any time",
            "Browse and choose from our available vehicles",
            "Select your preferred rental duration and time",
            "Book instantly, day or night",
            "Get your car when and where you need it"
        ],
        faqs: [
            {
                id: 1,
                heading: "Can I book a car at midnight or early morning?",
                content: "Yes, our booking system and support are active 24/7, so you can rent a car at any hour."
            },
            {
                id: 2,
                heading: "Are all vehicle types available 24/7?",
                content: "While most of our fleet is available around the clock, availability may vary slightly based on location and demand."
            },
            {
                id: 3,
                heading: "What if I need emergency support during odd hours?",
                content: "Our customer support team is available 24/7 to help with any issues, changes, or emergencies you may face."
            },
            {
                id: 4,
                heading: "Is there an extra fee for late-night pickups?",
                content: "No additional fee is charged for late-night bookings, but standard rental terms still apply."
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: "Phone Reservation",
        content: "Prefer to book by phone? Our friendly staff is ready to assist you with quick and convenient car reservations.",
        paragraphs: [
            "We make the rental process as simple as possible. If you’re more comfortable speaking with someone directly, our phone reservation service is just a call away.",
            "Whether you have questions, need help choosing a car, or want to book on the go, our trained staff is here to help 24/7."
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            "Quick and easy booking over the phone",
            "Assistance in selecting the right vehicle",
            "24/7 live customer support",
            "Secure and instant reservation confirmation",
            "Ideal for customers without internet access"
        ],
        process: [
            "Call our reservation hotline anytime",
            "Speak with a representative about your rental needs",
            "Choose a vehicle and confirm pickup details",
            "Receive confirmation via SMS or email",
            "Pick up your vehicle at the scheduled time"
        ],
        faqs: [
            {
                id: 1,
                heading: "What number can I call for reservations?",
                content: "You can reach us anytime at our dedicated reservation line: +92-XXX-XXXXXXX."
            },
            {
                id: 2,
                heading: "Is phone booking available 24/7?",
                content: "Yes, our phone reservation team is available around the clock to assist you."
            },
            {
                id: 3,
                heading: "Can I modify or cancel a phone reservation?",
                content: "Yes, simply call us again with your booking details, and we’ll help you make changes or cancel if needed."
            },
            {
                id: 4,
                heading: "Will I get a confirmation for my phone reservation?",
                content: "Yes, you will receive a confirmation message via SMS or email once your booking is complete."
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: "Reservation Anytime",
        content: "Reserve your car anytime, from anywhere. Our seamless booking system is open 24/7 to suit your schedule.",
        paragraphs: [
            "We know your plans don’t always follow business hours. That’s why we offer round-the-clock reservation options—online, via phone, or through our mobile app.",
            "Whether it’s late at night or early morning, you can book your vehicle instantly and securely with just a few clicks or a quick call."
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            "24/7 online and phone reservations",
            "Instant confirmation via email or SMS",
            "User-friendly website and mobile interface",
            "Real-time vehicle availability",
            "Flexible scheduling for pickup and drop-off"
        ],
        process: [
            "Visit our website or open our mobile app",
            "Select your desired vehicle and rental period",
            "Choose pickup and return details",
            "Confirm your booking securely anytime",
            "Receive a confirmation and get ready to ride"
        ],
        faqs: [
            {
                id: 1,
                heading: "Can I make a reservation outside business hours?",
                content: "Absolutely! Our system is always available for bookings, regardless of the time or day."
            },
            {
                id: 2,
                heading: "Is the mobile app available for reservations?",
                content: "Yes, you can book through our user-friendly app, which is available on both Android and iOS platforms."
            },
            {
                id: 3,
                heading: "How do I know if my booking is confirmed?",
                content: "You'll receive an instant confirmation via email or SMS after completing the reservation."
            },
            {
                id: 4,
                heading: "Can I modify a reservation made at night?",
                content: "Yes, modifications can be made anytime through our platform or by contacting support."
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: "Best Quality Cars",
        content: "Drive with confidence in our top-quality, well-maintained vehicles. We ensure every car meets the highest standards.",
        paragraphs: [
            "Your comfort and safety are our top priorities. That's why we maintain a fleet of high-quality cars from trusted manufacturers, regularly serviced and inspected for reliability.",
            "From stylish sedans to powerful SUVs, every vehicle in our lineup is selected for its comfort, cleanliness, and on-road performance."
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            "Fleet of premium, well-maintained vehicles",
            "Regular servicing and safety checks",
            "Clean and sanitized interiors",
            "Modern features and technology",
            "Options from trusted global car brands"
        ],
        process: [
            "Browse our premium vehicle collection online",
            "Read detailed descriptions and car specs",
            "Select your desired vehicle and schedule",
            "Complete the quick reservation process",
            "Enjoy a safe and luxurious ride"
        ],
        faqs: [
            {
                id: 1,
                heading: "What makes your cars high quality?",
                content: "We partner with top manufacturers and perform regular inspections and maintenance to ensure each car meets strict quality standards."
            },
            {
                id: 2,
                heading: "Are the cars cleaned before each rental?",
                content: "Yes, every vehicle is thoroughly cleaned and sanitized before each rental to ensure your comfort and hygiene."
            },
            {
                id: 3,
                heading: "Do you offer luxury or premium vehicles?",
                content: "Yes, our fleet includes a range of luxury sedans, SUVs, and more for customers seeking a premium experience."
            },
            {
                id: 4,
                heading: "Are all cars equipped with modern features?",
                content: "Absolutely. Our vehicles come with modern technology, including GPS, Bluetooth, air conditioning, and advanced safety systems."
            }
        ]
    }

];

export default services;